import { Grid, Typography } from '@mui/material';
import React, { useContext } from 'react'
import { ThemeContext } from '../../context/ThemeContext';
import { useTranslation } from 'react-i18next';

const OrderSummary = ({total,canceled}) => {
    const { darkMode } = useContext(ThemeContext)
    const { t } = useTranslation()

    const InfoRow = ({ label, value }) => (
        <Grid item xs={6}>
            <Grid container justifyContent="space-between">
                <Grid item>
                    <Typography variant="body2" color="text.secondary" >{t(label)}</Typography>
                </Grid>
                <Grid item>
                    <Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}>{value}</Typography>
                </Grid>
            </Grid>
        </Grid>
    );
    const infoItems = [
        { label: 'total', value:total },
        { label: 'canceled', value: canceled },
    ];

    return (
        <>
            <Grid container spacing={1} mb={1} p={1}>
                {infoItems.map((item, index) => (
                    <InfoRow key={index} label={item.label} value={item.value} />
                ))}
            </Grid>
        </>
    )
}

export default OrderSummary